export const API_URL_UTIL = {
  account: {
    root: 'account',
    loginInit: 'login/init',
    loginFinish: 'login/finish',
    loginWithEmailPassword: 'authenticate',
    forgotPasswordInit: 'account/reset-password/init',
    forgotPasswordFinish: 'account/reset-password/finish',
    refreshAccessToken: 'token/refresh',
  },
  settings: {
    changePassword: 'account/change-password',
  },
  microsoftLogin: {
    userDetails: 'https://graph.microsoft.com/v1.0/me',
  },
  foreman: {
    root: 'JobSchedule',
    getEmployeeDetailsByEmail: 'JobSchedule/GetEmployeeDetailsByEmail',
    foremanTaskList: 'JobSchedule/GetForemanJobList',
    getCrewPhaseDetailsByJobScheduleId: 'GetCrewPhaseDetailsbyJobScheduleId',
    saveJobScheduleLoggedHours: 'JobSchedule/SaveJobScheduleLoggedHours',
    getAllCompanies: 'JobSchedule/GetAllCompanies',
    getAllEmployeesByCompanyId: 'JobSchedule/NewGetAllEmployeesByCompanyId',
    saveCrewByJobScheduleId: 'JobSchedule/SaveCrewByJobScheduleId',
    getAllActivePhasesByJobScheduleId: `JobSchedule/GetAllActivePhasesByJobScheduleId`,
    savePhasesByJobScheduleId: 'JobSchedule/SavePhasesByJobScheduleId',
    jobSchedule: 'GetJobScheduleDetail',
    stoneConcreteHours: 'StoneConcreteBidReceivedHours',
    getEquipmentCategoryWiseList: 'GetEquipmentCategorywiseList',
    getCrewPerDiemDetails: 'JobSchedule/GetCrewPerDiemDetails',
    saveJobScheduleCrewPerDiem: 'JobSchedule/SaveJobScheduleCrewPerDiem',
    materialList: 'GetMaterialsListByJobscheduleId',
    vendorAdMixtureRejectReasonList: 'GetVenorAdmixtureRejectedList',
    saveStoneMaterialList: 'SaveStoneMaterialsList',
    saveConcreteMaterialList: 'SaveConcreteMaterialList',
    saveEquipmentsByJobScheduleId: 'SaveEquipmentsByJobScheduleId',
    getStoneConcreteReceivedHistory: 'StoneConcreteReceivedHistory',
    getHourlyTruckingDetails: 'HourlyTruckingDetails',
    addLogHours: 'PhaseHourlyTrucking',
    stoneMaterialDetail: 'StoneMaterialDetail',
    concreteMaterialDetail: 'ConcreteMaterialDetail',
    addSingleTAndMPhase: 'AddSingleTAndMPhase',
    jobs: 'jobs',
    quantities: 'quantities',
    updateQuantities: 'TodaysQuantities',
    getEquipmentsByJobScheduleId: 'JobEquipment',
    updateEquipmentsByJobScheduleId: 'JobEquipment',
    updateEquipmentsMeterByJobScheduleId: 'JobEquipmentMeter',
    uploadFile: 'UploadFileToSharePoint',
    observationData: 'ObservationData',
    addObservation: 'JobObservation',
    dailyReportDetails: 'dailyreportdetails',
    dailyTAndMReportDetails: 'tandmreportdetails',
    phaseProgress: 'phasesprogress',
    saveJobScheduleLoggedHoursUrl: 'saveJobScheduleLoggedHours',
    formsList: 'FormsList',
    sentUnsentFormsList: 'SentUnsentFormsList',
    removeForm: 'Deleteform',
    downloadForm: 'DownloadForm',
    savedSentUnsentForm: 'SavedSentUnsentForm',
    sendUnsentForm: 'SendUnsentForms',
    deletePerDiemApi:'JobSchedule/PerDiemData',
  },
  crew: {
    root: 'Crew',
    job: 'jobs',
    crewMember: 'CrewJobList',
    crewLoggeddhours: 'CrewLoggedhours',
    phaseEquipmentList: 'PhaseEquipmentList',
    loggedHours: 'LoggedHours',
  },
  shopManager: {
    root: 'ShopManager',
    costCode: 'CostCodes',
    jobsByCompany: 'CommanUser/AllJobsByCompanyId',
    scheduleJob: 'CommanUser/Schedulejob',
    scheduledJobs: 'ShopManager/ShopManagerJobList',
    SendEmailsTAndMReport: 'SendEmailforTandMReport',
    EquipmentCrewMembers: 'EquipmentCrewMembers',
    EquipmentLoggedHours: 'EquipmentLoggedHours',
    AllScheduleUnscheduleJobs: 'CommanUser/AllScheduleUnscheduleJobs',
  },
  mechanic: {
    root: 'Mechanic',
    totalLoggedHours: 'MechanicLoggedHours'
  }
};
